<template>
    <div id="rank-group">
        <div>
            <md-radio v-model="radio" value="purchase" @change="emitData('purchase')"></md-radio>
            <span class="rank-name">Purchase</span>
            <md-field class="input">
                <md-input class="input" v-model="rank.purchase.start"></md-input>
            </md-field> -
            <md-field  class="input">
                <md-input class="input" v-model="rank.purchase.end"></md-input>
            </md-field>
        </div>
        <div>
            <md-radio v-model="radio" value="product" @change="emitData('product')"></md-radio>
            <span class="rank-name">Product</span>
            <md-field class="input">
                <md-input class="input" v-model="rank.product.start"></md-input>
            </md-field> -
            <md-field  class="input">
                <md-input class="input" v-model="rank.product.end"></md-input>
            </md-field>
        </div>
        <div>
            <md-radio v-model="radio" value="payment" @change="emitData('payment')"></md-radio>
            <span class="rank-name">Payment</span>
            <md-field class="input">
                <md-input class="input" v-model="rank.payment.start"></md-input>
            </md-field> -
            <md-field  class="input">
                <md-input class="input" v-model="rank.payment.end"></md-input>
            </md-field>
        </div>                
        <!-- <div>
            <md-radio v-model="radio" value="product" @change="emitData('product')"></md-radio>
            <span class="rank-name">Product</span>
            <md-input class="input" v-model="product_start" maxlength="8"></md-input> -
            <md-input class="input" v-model="product_end" maxlength="8"></md-input>
        </div>
        <div>
            <md-radio v-model="radio" value="payment" @change="emitData('payment')"></md-radio>
            <span class="rank-name">Payment</span>
            <md-input class="input" v-model="payment_start" maxlength="8"></md-input> -
            <md-input class="input" v-model="product_end" maxlength="8"></md-input>
        </div> -->

        <!-- {{rank}} -->
        <!-- <button class="btn-rank" @click="btnA=!btnA;emitData()" v-bind:class="{ selected: btnA }">A</button>
        <button class="btn-rank" @click="btnB=!btnB;emitData()" v-bind:class="{ selected: btnB }">B</button>
        <button class="btn-rank" @click="btnC=!btnC;emitData()" v-bind:class="{ selected: btnC }">C</button>
        <button class="btn-rank" @click="btnD=!btnD;emitData()" v-bind:class="{ selected: btnD }">D</button> -->
    </div>

</template>

<script>
export default {
    name: 'rank-group',
    props: ['value'],
    //  props: {
    //     rankName:{
    //         type: String,
    //         default: ""
    //     }
    // },
    data(){
        return {
            radio: "purchase",
            purchase_start: 1,
            purchase_end: 0,
            product_start:1,
            product_end:0,
            payment_start:1,
            payment_end:0,
            // btnA: false,
            // btnB: false,
            // btnC: false,
            // btnD: false,
            // campaign: this.value,
            rank: this.value
        }
    },
    watch:{
        // radio(){
        //     console.log('radio')
        //     if(this.rank == 'purchase') value.purchase.selected = true;
        //     else if(this.rank == 'product') value.product.selected = true;
        //     else if(this.rank == 'payment') value.payment.selected = true;
        // },
        "value.purchase.selected"(){
            console.log('watch purchase');
            this.radio = 'purchase';
        },
        "value.product.selected"(){
            console.log('watch product');
            this.radio = 'product';
        },
        "value.payment.selected"(){
            console.log('watch payment');
            this.radio = 'payment';
        }
        // rank(){
        //     this.value = this.rank;
        // }
    },
    created(){
        if(this.value.rank_value == null){
            // this.rank = {
            //     purchase: { 
            //         selected: true,
            //         start : 0, 
            //         end : 0
            //     },
            //     product: {                     
            //         selected: false,
            //         start : 0, 
            //         end : 0
            //     },
            //     payment: {                     
            //         selected: false,
            //         start : 0, 
            //         end : 0
            //     }
            // }
            // this.$emit('input',{'A':this.btnA,'B':this.btnB,'C':this.btnC,'D':this.btnD});
            
        }
        else
        {
            // this.btnA = this.value.A? this.value.A:false;
            // this.btnB = this.value.B? this.value.B:false;
            // this.btnC = this.value.C? this.value.C:false;
            // this.btnD = this.value.D? this.value.D:false;
            // this.$emit('input',{'A':this.btnA,'B':this.btnB,'C':this.btnC,'D':this.btnD});
        }
    },
    methods:{
        emitData(rank) {

            if(rank == 'purchase') {
                this.rank.purchase.selected = true;
                this.rank.product.selected = false;
                this.rank.payment.selected = false;
            }
            else if(rank == 'product') {
                this.rank.purchase.selected = false;
                this.rank.product.selected = true;
                this.rank.payment.selected = false;
            }
            else if(rank == 'payment') {
                this.rank.purchase.selected = false;
                this.rank.product.selected = false;
                this.rank.payment.selected = true;
            }
            
        }
    }
}

</script>

<style lang="scss" scoped>

#rank-group{
    margin-top: 10px;
    margin-bottom: 10px;
    
    .rank-name {
        width:100px;
        margin-right:10px;
        display: inline-block;
    }
    
    .input{
        font-size:16px !important;
        padding:3px;
        width:90px;
        text-align:right;
        // float: right;
        display: inline;

        .md-count{
            display: none !important;
        }
    }

    // .btn-rank {
    //     display: inline-block;
    //     text-align: center;
    //     text-decoration: none;

    //     width:50px;
    //     height:25px;
    //     margin-right:5px;

    //     border: 0 none #A8A8A8;
    //     border-bottom: 2px solid #A8A8A8;


    //     background-color: white; /* Green */
    //     color:#A8A8A8;
    //     font-size: 16px;
    //     font-weight: bold;
    // }

    // .btn-rank {
    // background-position: center;
    // transition: background 0.8s;
    // }

    // .btn-rank:hover {
    //     cursor: pointer;
    //     color: #3F51B5;
    // }

    // .btn-rank:active {
    //     background-size: 100%;
    //     transition: background 0s;
    // }

    // .selected {
    //     cursor: pointer;
    //     border: 0 none #ccc;
    //     border-bottom: 2px solid blue;
    //     color: #3F51B5;
    // }

}









</style>
